export const saveScrollAction = (payload) => {
    return {
        type: "saveScroll",
        payload
    }
}